import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DocumentTypeLetterRulling } from './documenttypeletterrulling';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { DocumenttypeletterrullingService } from './documenttypeletterrulling.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

declare var $: any;

@Component({
  selector: 'app-documenttypeletterrulling',
  templateUrl: './documenttypeletterrulling.component.html',
  styleUrls: ['./documenttypeletterrulling.component.css']
})
export class DocumenttypeletterrullingComponent implements OnInit {

  sendMenuId: number;
  sendPageName: string = 'DocumentTypeLetterRulling';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;
  documenttypeletterrullingForm: FormGroup;
  documenttypeletterrullings: DocumentTypeLetterRulling[] = [];
  documenttypeletterrullingsactive: DocumentTypeLetterRulling[] = [];
  documenttypeletterrulling: DocumentTypeLetterRulling;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  documenttypeletterrullingModalRef: BsModalRef;
  operation: string;
  userid: number;
  documenttypeletterrullingid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'documenttypeletterrulling'; //set default
  reverse: boolean = false;

  constructor(
    private documenttypeletterrullingservice: DocumenttypeletterrullingService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      // console.log(this.router.getCurrentNavigation().extras.state);
      localStorage.setItem('DocumentTypeLetterRulling_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('DocumentTypeLetterRulling_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('DocumentTypeLetterRulling_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('DocumentTypeLetterRulling_action');
    }
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    this.documenttypeletterrullingForm = this.formBuilder.group({
      documenttypeletterrullingid: [''],
      documenttypeletterrulling: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  getactiveinactive(showallp) {
    this.documenttypeletterrullingsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.documenttypeletterrullings.forEach(data => {
        if (data.active == 1) {
          this.documenttypeletterrullingsactive.push(data);
        }
      });
      this.documenttypeletterrullings = [];
      this.documenttypeletterrullings = this.documenttypeletterrullingsactive;
    }
    else {
      this.showall = true;
      this.documenttypeletterrullings = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedLetterRullings");
    let data = arrays.find(ob => ob['name'] === 'Document Type Letter Rullings');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedLetterRullings","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedLetterRullings",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.documenttypeletterrullingModalRef.hide();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.documenttypeletterrullings = [];
    this.documenttypeletterrullingsactive = [];
    this.documenttypeletterrullingservice.Get().subscribe(res => {
      this.documenttypeletterrullings = res;
      if (this.showallstatus == true) {
        this.documenttypeletterrullings.forEach(data => {
          if (data.active == 1) {
            this.documenttypeletterrullingsactive.push(data);
          }
        });
        this.documenttypeletterrullings = [];
        this.documenttypeletterrullings = this.documenttypeletterrullingsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  get g() { return this.documenttypeletterrullingForm.controls; }

  Post(documenttypeletterrulling: DocumentTypeLetterRulling) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.documenttypeletterrullingForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.documenttypeletterrullingForm.errors);
    //}

    if ((documenttypeletterrulling.documenttypeletterrulling.trim() == undefined) || (documenttypeletterrulling.documenttypeletterrulling.trim() == '')) {
      this.toastr.error('DocumentTypeLetterRulling should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    documenttypeletterrulling.documenttypeletterrulling = documenttypeletterrulling.documenttypeletterrulling.trim();
    if (this.operation == 'add') {

      documenttypeletterrulling.createdby = this.userid;
      msg = "Record Added Successfully";
      this.documenttypeletterrullingservice.Post(documenttypeletterrulling).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.documenttypeletterrullingModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      documenttypeletterrulling.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.documenttypeletterrullingservice.Put(documenttypeletterrulling).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.documenttypeletterrullingModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.documenttypeletterrullingForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.documenttypeletterrullingForm.value.active = 1;
    } else {
      this.documenttypeletterrullingForm.value.active = 0
    }
  }

  OpenConfirmTemplate(documenttypeletterrulling, template: TemplateRef<any>) {
    if (documenttypeletterrulling.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.documenttypeletterrulling = documenttypeletterrulling;

          this.Delete();

        }

      });

  }

  Delete() {
    var msg;
    if (this.documenttypeletterrulling.active == 0) {
      this.documenttypeletterrulling.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.documenttypeletterrulling.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    
    this.documenttypeletterrulling.modifiedby = this.userid;
    this.documenttypeletterrullingservice.Delete(this.documenttypeletterrulling).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }

  hidePopup() {
    this.documenttypeletterrullingModalRef.hide();
  }

  openDocumentTypeLetterRullingModal(template: TemplateRef<any>, type, documenttypeletterrulling?: DocumentTypeLetterRulling) {

    this.operation = type

    if (type == 'update') {
      this.documenttypeletterrullingForm.controls['documenttypeletterrullingid'].setValue(documenttypeletterrulling.documenttypeletterrullingid);
      this.documenttypeletterrullingForm.controls['documenttypeletterrulling'].setValue(documenttypeletterrulling.documenttypeletterrulling);
      this.documenttypeletterrullingForm.controls['active'].setValue(documenttypeletterrulling.active);
      this.documenttypeletterrulling = documenttypeletterrulling;
    }
    if (type == 'add') {
      this.documenttypeletterrullingForm.controls['documenttypeletterrullingid'].setValue(0);
      this.documenttypeletterrullingForm.controls['documenttypeletterrulling'].setValue('');
      this.documenttypeletterrullingForm.controls['active'].setValue(1);
    }
    this.documenttypeletterrullingModalRef = this.modalService.show(template, this.config);

    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }


}
